(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
/**
 * StickyFooter Custom Element
 * ----------------------------
 * Makes the footer "stick" to the bottom of the viewport so that
 * page sections above it scroll over the top of it — mirroring the
 * sticky-header scroll-over pattern used in the Dawn header.
 *
 * How it works:
 *  1. The <sticky-footer> wrapper gets `position: sticky; bottom: 0`
 *     via CSS (injected above when enable_sticky_footer is true).
 *  2. Every sibling shopify section above the footer is given
 *     `position: relative; z-index: 2` and an opaque background so
 *     they visually slide over the footer.
 *  3. A bottom padding equal to the footer height is added to the body
 *     so the page doesn't "jump" when the footer becomes sticky.
 *  4. The element listens for Shopify theme-editor section:load events
 *     so it recalculates after live customizer changes.
 */
class StickyFooter extends HTMLElement {
  constructor() {
    super();
    this._resizeObserver = null;
  }

  connectedCallback() {
    // Wait one frame so the DOM is fully painted
    requestAnimationFrame(() => this._init());

    // Re-init on theme editor section reload (live preview)
    document.addEventListener('shopify:section:load', (e) => {
      if (e.detail && e.detail.sectionId === this.dataset.sectionId) {
        requestAnimationFrame(() => this._init());
      }
    });
  }

  disconnectedCallback() {
    this._cleanup();
  }

  _init() {
    this._cleanup();
    this._applyBodyPadding();
    this._setupResizeObserver();
  }

  /**
   * Add padding-bottom to the <body> equal to the footer height so the
   * page content doesn't get permanently hidden behind the sticky footer.
   */
  _applyBodyPadding() {
    const height = this.offsetHeight;
    document.body.style.paddingBottom = `${height}px`;
  }

  /**
   * Watch for footer height changes (e.g. newsletter form expands, fonts
   * load, viewport resizes) and keep the body padding in sync.
   */
  _setupResizeObserver() {
    if (typeof ResizeObserver === 'undefined') return;

    this._resizeObserver = new ResizeObserver(() => {
      this._applyBodyPadding();
    });
    this._resizeObserver.observe(this);
  }

  _cleanup() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
    // Reset body padding when the element is removed (e.g. feature toggled off)
    document.body.style.paddingBottom = '';
  }
}

customElements.define('sticky-footer', StickyFooter);

  } catch(e) { console.error(e); }
})();
})();
